// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__FPmnh","head":"Table_head__3MMbd","col":"Table_col__3td4Q"};